// TODO: consider making this a pure function
const isDir = async (dirPath: string) => {
  try {
    const stat = await window.pfs.stat(dirPath);
    return await stat.isDirectory();
  } catch (err) {
    // if the directory doesn't exist, return false; else, rethrow
    if ((err as any).code === 'ENOENT') return false;
    throw err;
  }
};

// TODO: consider making this a pure function
const listDir = async (dirPath: string) => {
  return await window.pfs.readdir(dirPath);
};

export { isDir, listDir };
